import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initParse } from "./lib/parse";
import { bootstrapLegacyStorage } from "./lib/auth";
import "./i18n";

initParse();
bootstrapLegacyStorage();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
